import articlesFiles from "src/content/articles";
import referenceFiles from "src/content/reference";
import toolsFiles from "src/content/tools";


export default {
  'articles': articlesFiles,
  'reference': referenceFiles,
  'tools': toolsFiles
}

